import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import LimitWarning from '../components/common/LimitWarning';

const AdminDashboard = () => {
  const { currentUser } = useAppContext();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect if not admin or company_admin
    if (currentUser && !['admin', 'admin'].includes(currentUser.role)) {
      navigate('/');
      return;
    }
  }, [currentUser, navigate]);

  return (
    <div className="max-w-7xl mx-auto py-10 px-4 sm:px-6 lg:px-8">
      <div className="mb-8">
        <LimitWarning limitType="users" />
        <LimitWarning limitType="monthly_appreciations" />

        <h1 className="text-3xl font-bold text-gray-900">Admin Dashboard</h1>
        <p className="mt-2 text-sm text-gray-600">Manage your Apprecio instance.</p>
      </div>

      {/* Quick Links */}
      <div className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">Admin Tools</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white rounded-lg shadow hover:shadow-lg transition-shadow p-6">
            <h3 className="text-lg font-medium text-gray-900 mb-2">Culture Analytics</h3>
            <p className="text-sm text-gray-500 mb-4">Track engagement and recognition culture metrics</p>
            <button
              onClick={() => navigate('/analytics')}
              className="text-sm text-blue-600 hover:text-blue-800 font-medium"
            >
              View Culture Analytics →
            </button>
          </div>
          <div className="bg-white rounded-lg shadow hover:shadow-lg transition-shadow p-6">
            <h3 className="text-lg font-medium text-gray-900 mb-2">Users Management</h3>
            <p className="text-sm text-gray-500 mb-4">Manage users, roles, and permissions</p>
            <button
              onClick={() => navigate('/admin/users')}
              className="text-sm text-blue-600 hover:text-blue-800 font-medium"
            >
              Manage Users →
            </button>
          </div>
          <div className="bg-white rounded-lg shadow hover:shadow-lg transition-shadow p-6">
            <h3 className="text-lg font-medium text-gray-900 mb-2">Invitations</h3>
            <p className="text-sm text-gray-500 mb-4">Send and manage user invitations</p>
            <button
              onClick={() => navigate('/admin/invitations')}
              className="text-sm text-blue-600 hover:text-blue-800 font-medium"
            >
              Manage Invitations →
            </button>
          </div>
          <div className="bg-white rounded-lg shadow hover:shadow-lg transition-shadow p-6">
            <h3 className="text-lg font-medium text-gray-900 mb-2">Company Settings</h3>
            <p className="text-sm text-gray-500 mb-4">Configure company branding and preferences</p>
            <button
              onClick={() => navigate('/admin/settings')}
              className="text-sm text-blue-600 hover:text-blue-800 font-medium"
            >
              Edit Settings →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;